// Lightweight, consent-friendly analytics event helper.
// Pushes to window.dataLayer so GA4 / GTM / Search Console tagging can be
// connected later without code changes. No tracking id is hardcoded.
export const track = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};
